import styled from "styled-components/macro";
import tw from "tailwind.macro";

const Copy = styled.div`
  ${tw``}
  p {
  }
`;
export default Copy;
